var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 119,
    viewBox: "0 0 103 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 60.6768,
    r: 51.5,
    transform: "rotate(-90 51.5 60.6768)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5437 25.0458C52.3071 25.0479 52.9242 25.6685 52.9221 26.4319L52.7376 93.4176C52.7355 94.1809 52.1149 94.7981 51.3515 94.796C50.5881 94.7939 49.971 94.1733 49.9731 93.4099L50.1576 26.4243C50.1597 25.6609 50.7803 25.0437 51.5437 25.0458Z",
    fill: "#173930"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9774 60.9906C16.4376 60.4508 16.4376 59.5756 16.9774 59.0358L50.5625 25.4507C51.1023 24.9109 51.9775 24.9109 52.5173 25.4507L85.9178 58.8512C86.4576 59.391 86.4576 60.2662 85.9178 60.8061C85.378 61.3459 84.5028 61.3459 83.963 60.806L51.5399 28.3829L18.9322 60.9906C18.3924 61.5304 17.5172 61.5304 16.9774 60.9906Z",
    fill: "#173930"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/arrow-top.46d85216ba8a1d50046523758917067f.svg";
export { ForwardRef as ReactComponent };